import request from "./api";
/**
 *    testExamApi   测验和考试中开始考试或作答api
 * */
// 交卷
export const submitTest = (examPaperId, paperId, params, opts) =>
    request('/api-study/sumbit/exam/before/'+examPaperId+'/'+paperId, params, {
        ...opts,
        method: 'post'
    });
export const submitTestNew = (examPaperId, paperId, params, opts) =>
    request('/api-teachingaffair/globalExamAnswerRecord/sumbitExamBeforeCheck/'+examPaperId+'/'+paperId, params, {
        ...opts,
        method: 'post'
    });

export const submitExam = (examPaperId, classId,params, opts) =>
    request('/api-study/sumbit/exam/'+examPaperId+'/'+classId, params, {
        ...opts,
        method: 'post'
    });
export const submitExamNew = (examPaperId, classId,params, opts) =>
    request('/api-teachingaffair/globalExamAnswerRecord/sumbit/exam/'+examPaperId, params, {
        ...opts,
        method: 'post'
    });

export const addToResRecord = (params, opts) =>
    request('/api-study/study/addToResRecord', params, {
        ...opts,
        method: 'post'
    });

export const cancelRemark = (examPaperId, questionId, params, opts) =>
    request('/api-study/cancel/remark/question/'+examPaperId+'/'+questionId, params, {
        ...opts,
        method: 'post'
    });
export const cancelRemarkNew = (examPaperId, questionId, params, opts) =>
    request('/api-teachingaffair/globalExamAnswerRecord/cancel/remark/question/'+examPaperId+'/'+questionId, params, {
        ...opts,
        method: 'post'
    });

export const remark = (examPaperId, questionId, internalTypeId, params, opts) =>
    request('/api-study/remark/question/'+examPaperId+'/'+questionId+'/'+internalTypeId, params, {
        ...opts,
        method: 'post'
    });
export const remarkNew = (examPaperId, questionId, internalTypeId, params, opts) =>
    request('/api-teachingaffair/globalExamAnswerRecord/remark/question/'+examPaperId+'/'+questionId+'/'+internalTypeId, params, {
        ...opts,
        method: 'post'
    });

export const classQuery = (classId, params, opts) =>
    request('/api-course/class/query/'+classId, params, {
        ...opts
    });

export const recordExam = (params, opts) =>
    request('/api-study/save/operate/exam/record', params, {
        ...opts,
        method: 'post'
    });

export const fzUrlExam = (examStudentId, itemId, time, params, opts) =>
    request(`/api-exam/exam/fzUrl?cid=${examStudentId}&item=${itemId}&r=${time}`, params, {
        ...opts,
        method: 'post'
    });
// 根据资源ID 获取动态参数列表
export const getParams = (questionId, params, opts) =>
    request('/api-resource/dynmaicParam/get/dynmaic/param/'+questionId, params, {
        ...opts
    });



// WEBPACK FOOTER //
// ./src/api/testExamApi.js